import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import StandardPackage from './standard-package';

class Component extends BaseComponent {
    render({ packages }) {
        if (packages) {
            return (
                <standard-packages>
                    {packages.map((pkg) => (this.renderPackage(pkg)))}
                </standard-packages>
            );
        }

        return (
            <standard-packages />
        );
    }

    renderPackage(pkg) {
        return (
            <StandardPackage
                upc={pkg.upc}
                coins={pkg.paid_kcs + pkg.free_kcs}
                price={pkg.usd.current}
                percent={pkg.percent}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    packages: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard,
});

export default connect(mapStateToProps)(Component);


